export enum EPaymentMethod {
  ACH = 'ACH',
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  DEBIT_CARD = 'DEBIT_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
}

export enum EVerificationMethod {
  INSTANT = 'INSTANT',
  MANUAL = 'MANUAL',
}

export enum EBankAccountType {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
}

export enum EPaymentStatus {
  INIT = 'INIT',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export enum EMethodVerificationStatus {
  NOT_VERIFIED = 'NOT_VERIFIED',
  IN_VERIFICATION = 'IN_VERIFICATION',
  VERIFIED = 'VERIFIED',
  FAILED = 'FAILED',
}
